import React, { useState } from 'react';
import SectionEyebrow from '../components/SectionEyebrow';
import { usePage, img } from '../lib/content';
import SmartMedia from '../components/SmartMedia';
import { X } from 'lucide-react';

const Gallery = () => {
  const c = usePage('gallery');
  const images = Array.isArray(c.images) ? c.images : [];
  const [active, setActive] = useState(null);

  return (
    <div className="bg-[#f7f1e3] pt-32 lg:pt-40 pb-24 lg:pb-32" data-testid="gallery-page">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionEyebrow>{c.eyebrow}</SectionEyebrow>
        <h1 className="font-serif text-[#942222] text-[48px] md:text-[72px] lg:text-[96px] leading-[1.02] tracking-[-0.02em] mt-5 max-w-4xl">
          {c.title}
        </h1>
        <p className="mt-6 text-[#942222]/80 max-w-xl text-[16px] leading-relaxed">
          {c.body}
        </p>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
          {images.map((src, i) => (
            <button
              key={i}
              onClick={() => setActive(img(src))}
              data-testid={`gallery-tile-${i}`}
              className={`group relative overflow-hidden ${
                i % 7 === 0 ? 'row-span-2 aspect-[3/5]' : 'aspect-[4/5]'
              }`}
            >
              <SmartMedia
                src={src}
                alt={`Millpond ${i + 1}`}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors" />
            </button>
          ))}
        </div>
      </section>

      {active && (
        <div
          className="fixed inset-0 z-[80] bg-black/85 flex items-center justify-center p-6 lg:p-12"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={() => setActive(null)}
            aria-label="Close"
            className="absolute top-6 right-6 text-[#f1ead9] p-2"
            data-testid="gallery-lightbox-close"
          >
            <X size={28} />
          </button>
          <img src={active} alt="Gallery item" className="max-h-full max-w-full object-contain" />
        </div>
      )}
    </div>
  );
};

export default Gallery;
